<template>
  <div class="pa-4">
    <v-row class="align-center mb-4" dense>
      <v-col cols="12" sm="auto">
        <v-btn
          v-if="!apiMode"
          color="red-darken-3"
          variant="flat"
          :loading="saving"
          @click="persist"
        >
          <v-icon start> mdi-content-save </v-icon>
          {{ $t("leko_employees.car_part_groups.grafiche_save_catalog") }}
        </v-btn>
      </v-col>
      <v-col cols="12" sm="auto">
        <v-btn
          v-if="!apiMode"
          color="grey-darken-3"
          variant="outlined"
          @click="openEditor(null)"
        >
          <v-icon start> mdi-plus </v-icon>
          {{ $t("leko_employees.car_part_groups.grafiche_add_category") }}
        </v-btn>
      </v-col>
      <v-col cols="12" sm="auto">
        <v-btn
          color="grey-darken-2"
          variant="text"
          :loading="reloadLoading"
          @click="reload"
        >
          <v-icon start> mdi-refresh </v-icon>
          {{ $t("leko_employees.car_part_groups.grafiche_reload_from_server") }}
        </v-btn>
      </v-col>
      <v-col cols="12">
        <v-alert
          v-if="apiMode"
          type="info"
          density="compact"
          variant="tonal"
          class="mt-2"
        >
          {{
            $t("leko_employees.car_part_groups.grafiche_api_categories_hint")
          }}
        </v-alert>
      </v-col>
      <v-col cols="12">
        <v-alert
          v-if="banner"
          :type="banner.type"
          density="compact"
          class="mt-2"
          closable
          @click:close="banner = null"
        >
          {{ banner.text }}
        </v-alert>
      </v-col>
    </v-row>

    <v-table density="comfortable" class="grafiche-cat-table rounded border">
      <thead>
        <tr>
          <!--
          <th class="text-left">
            {{ $t("leko_employees.car_part_groups.grafiche_sort") }}
          </th>
          <th class="text-left">
            {{ $t("leko_employees.car_part_groups.grafiche_code") }}
          </th>
          -->
          <th class="text-left">IT</th>
          <th class="text-left">EN</th>
          <th class="text-left">SQ</th>
          <th v-if="!apiMode" class="text-right width-actions">
            {{ $t("leko_employees.car_part_groups.grafiche_actions") }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(cat, idx) in sortedCategoriesView"
          :key="cat.categoryCode || idx"
          :class="idx % 2 === 0 ? 'bg-grey-lighten-4' : ''"
        >
          <!--
          <td style="max-width: 100px">
            <v-text-field
              v-model.number="cat.sortOrder"
              type="number"
              hide-details
              density="compact"
              variant="outlined"
              :disabled="apiMode"
            />
          </td>
          <td style="max-width: 140px">
            <v-text-field
              v-model="cat.categoryCode"
              hide-details
              density="compact"
              variant="outlined"
              disabled
            />
          </td>
          -->
          <td>
            <v-text-field
              v-model="cat.title.it"
              hide-details
              density="compact"
              variant="outlined"
              :readonly="apiMode"
            />
          </td>
          <td>
            <v-text-field
              v-model="cat.title.en"
              hide-details
              density="compact"
              variant="outlined"
              :readonly="apiMode"
            />
          </td>
          <td>
            <v-text-field
              v-model="cat.title.sq"
              hide-details
              density="compact"
              variant="outlined"
              :readonly="apiMode"
            />
          </td>
          <td v-if="!apiMode" class="text-right">
            <v-btn
              icon
              variant="text"
              color="red-darken-2"
              @click="confirmDelete(cat)"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
            <v-btn
              icon
              variant="text"
              color="grey-darken-2"
              @click="openEditor(cat)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </td>
        </tr>
      </tbody>
    </v-table>

    <v-dialog v-model="editDialog" max-width="520">
      <v-card>
        <v-card-title class="redColor text-white d-flex">
          <span>{{
            editingCategory
              ? $t("leko_employees.car_part_groups.grafiche_edit_category")
              : $t("leko_employees.car_part_groups.grafiche_add_category")
          }}</span>
          <v-spacer />
          <v-btn icon variant="text" color="white" @click="editDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-text-field
            v-model="editor.code"
            :label="$t('leko_employees.car_part_groups.grafiche_code')"
            :disabled="!!editingCategory"
            variant="outlined"
            hide-details
            class="mb-3"
          />
          <v-text-field
            v-model.number="editor.sortOrder"
            type="number"
            :label="$t('leko_employees.car_part_groups.grafiche_sort')"
            variant="outlined"
            hide-details
            class="mb-3"
          />
          <v-text-field
            v-model="editor.it"
            label="Italiano"
            variant="outlined"
            hide-details
            class="mb-3"
          />
          <v-text-field
            v-model="editor.en"
            label="English"
            variant="outlined"
            hide-details
            class="mb-3"
          />
          <v-text-field
            v-model="editor.sq"
            label="Shqip"
            variant="outlined"
            hide-details
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="outlined" @click="editDialog = false">
            {{ $t("leko_employees.car_part_groups.close") }}
          </v-btn>
          <v-btn color="red-darken-3" variant="flat" @click="applyEditor">
            {{ $t("leko_employees.car_part_groups.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="400">
      <v-card>
        <v-card-title>
          {{ $t("leko_employees.car_part_groups.grafiche_delete_title") }}
        </v-card-title>
        <v-card-text>
          {{ $t("leko_employees.car_part_groups.grafiche_delete_hint") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="deleteDialog = false">
            {{ $t("leko_employees.car_part_groups.close") }}
          </v-btn>
          <v-btn color="error" variant="flat" @click="doDeleteCategory">
            {{ $t("leko_employees.car_part_groups.grafiche_delete_confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  loadGraficheCatalog,
  saveGraficheCatalog,
} from "@/services/graficheCatalogAdminStore.js";
import { fetchPartCategoryGroupsCategoriesOnly } from "@/services/partCategoryGroupsCatalog.js";
import { buildMockTitlesForCategory } from "@/data/infocarGraficheCategories.js";

function slugCode(text) {
  const base =
    text
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_|_$/g, "") || "grafiche";
  return `graf_${base}`.slice(0, 64);
}

export default {
  name: "GraficheCategoriesTab",

  data: () => ({
    apiMode: false,
    reloadLoading: false,
    catalog: { categories: [], linesByCategory: {} },
    saving: false,
    banner: null,
    editDialog: false,
    deleteDialog: false,
    categoryToDelete: null,
    editingCategory: null,
    editor: {
      code: "",
      sortOrder: 1,
      it: "",
      en: "",
      sq: "",
    },
  }),

  computed: {
    sortedCategoriesView() {
      const list = this.catalog.categories || [];
      return [...list].sort(
        (a, b) => (Number(a.sortOrder) || 0) - (Number(b.sortOrder) || 0),
      );
    },
  },

  mounted() {
    this.reload();
  },

  methods: {
    async reload() {
      this.reloadLoading = true;
      this.banner = null;
      try {
        const snap = await fetchPartCategoryGroupsCategoriesOnly();
        if (snap.categories?.length > 0) {
          this.apiMode = true;
          this.catalog = {
            categories: snap.categories.map((c) => ({ ...c })),
            linesByCategory: {},
          };
        } else {
          throw new Error("empty categories");
        }
      } catch {
        this.apiMode = false;
        this.catalog = loadGraficheCatalog();
      }

      for (const c of this.catalog.categories) {
        if (!c.title) c.title = { it: "", en: "", sq: "" };
        if (c.title.it == null) c.title.it = "";
        if (c.title.en == null) c.title.en = "";
        if (c.title.sq == null) c.title.sq = "";
      }
      this.reloadLoading = false;
    },

    persist() {
      this.saving = true;
      try {
        const codes = new Set();
        for (const c of this.catalog.categories) {
          if (!c.categoryCode?.trim()) {
            this.banner = {
              type: "error",
              text: this.$t(
                "leko_employees.car_part_groups.grafiche_err_empty_code",
              ),
            };
            return;
          }
          if (codes.has(c.categoryCode)) {
            this.banner = {
              type: "error",
              text: this.$t(
                "leko_employees.car_part_groups.grafiche_err_dup_code",
              ),
            };
            return;
          }
          codes.add(c.categoryCode);
        }
        saveGraficheCatalog(this.catalog);
        this.banner = {
          type: "success",
          text: this.$t("leko_employees.car_part_groups.grafiche_saved_ok"),
        };
      } finally {
        this.saving = false;
      }
    },

    openEditor(cat) {
      this.editingCategory = cat;
      if (cat) {
        this.editor = {
          code: cat.categoryCode,
          sortOrder: Number(cat.sortOrder) || 0,
          it: cat.title?.it ?? "",
          en: cat.title?.en ?? "",
          sq: cat.title?.sq ?? "",
        };
      } else {
        const next =
          Math.max(
            0,
            ...this.catalog.categories
              .map((x) => Number(x.sortOrder))
              .filter(Number.isFinite),
          ) + 1;
        this.editor = {
          code: "",
          sortOrder: next,
          it: "",
          en: "",
          sq: "",
        };
      }
      this.editDialog = true;
    },

    applyEditor() {
      const codeRaw = this.editor.code?.trim();
      const sortOrder = Number(this.editor.sortOrder) || 1;

      if (!this.editingCategory) {
        const code =
          codeRaw ||
          slugCode(
            (this.editor.it || "").trim() || `cat_${Date.now().toString(36)}`,
          );
        if (this.catalog.categories.some((c) => c.categoryCode === code)) {
          this.banner = {
            type: "error",
            text: this.$t(
              "leko_employees.car_part_groups.grafiche_err_dup_code",
            ),
          };
          return;
        }
        this.catalog.categories.push({
          categoryCode: code,
          sortOrder,
          title: {
            it: this.editor.it ?? "",
            en: this.editor.en ?? "",
            sq: this.editor.sq ?? "",
          },
        });
        this.catalog.linesByCategory[code] = buildMockTitlesForCategory(
          code,
        ).map((row) => ({
          _id: row._id,
          partCode: row.partCode,
          title: { ...row.title },
        }));
      } else {
        const oldCode = this.editingCategory.categoryCode;
        Object.assign(this.editingCategory, {
          sortOrder,
          title: {
            it: this.editor.it ?? "",
            en: this.editor.en ?? "",
            sq: this.editor.sq ?? "",
          },
        });
        const newCode =
          codeRaw && codeRaw.trim() !== oldCode ? codeRaw.trim() : oldCode;

        if (newCode !== oldCode) {
          if (
            this.catalog.categories.some(
              (c) => c.categoryCode === newCode && c !== this.editingCategory,
            )
          ) {
            this.banner = {
              type: "error",
              text: this.$t(
                "leko_employees.car_part_groups.grafiche_err_dup_code",
              ),
            };
            return;
          }
          this.editingCategory.categoryCode = newCode;
          this.catalog.linesByCategory[newCode] =
            this.catalog.linesByCategory[oldCode] || [];
          delete this.catalog.linesByCategory[oldCode];
        }
      }
      this.editDialog = false;
      this.persist();
    },

    confirmDelete(cat) {
      this.categoryToDelete = cat;
      this.deleteDialog = true;
    },

    doDeleteCategory() {
      const cat = this.categoryToDelete;
      if (!cat) return;
      this.catalog.categories = this.catalog.categories.filter(
        (x) => x.categoryCode !== cat.categoryCode,
      );
      delete this.catalog.linesByCategory[cat.categoryCode];
      this.deleteDialog = false;
      this.categoryToDelete = null;
      this.persist();
    },
  },
};
</script>

<style scoped>
.width-actions {
  width: 120px;
}
.grafiche-cat-table {
  overflow-x: auto;
}
</style>
